// Port of Flutter's favDevicesScreen.dart — the first tab.
//
// AppBar reads "Welcome, <Name> <Surname>". The grid is the Dart's
// maxCrossAxisExtent 250 / aspect 0.9 / spacing 10 / padding 8, and each card
// shows the device picture, its auto-scrolling name and a 📍Location > Room
// line. Like the Dart, an empty favourites list bounces the user to the
// Locations tab once (so a fresh account doesn't land on an empty screen).

import React, { useEffect, useRef } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CenterTitleBar } from '../../components/MobileAppBar';
import DeviceCard from '../../components/DeviceCard';
import ExtentGrid from '../../components/ExtentGrid';
import { useApp } from '../../../../core/state/AppContext';

export default function FavouritesTab({ goTab }) {
  const theme = useTheme();
  const c = theme.sli;
  const navigate = useNavigate();
  const {
    user, favourites, favouritesLoading, refreshFavourites, toggleFavourite,
  } = useApp();
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (favouritesLoading || redirectedRef.current) return;
    if (favourites.length === 0) {
      redirectedRef.current = true;
      goTab(1);
    }
  }, [favourites, favouritesLoading, goTab]);

  const who = user ? `${user.Name || ''} ${user.Surname || ''}`.trim() : 'User';

  const openDevice = (d) => navigate(`/device/${d.UniqueNumber}`, { state: { device: d } });
  const onStar = async (d, isFav) => { await toggleFavourite(d, isFav); await refreshFavourites(); };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', bgcolor: c.back }}>
      <CenterTitleBar title={`Welcome, ${who || 'User'}`} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', p: 1 }}>
        {favourites.length === 0 ? (
          <Typography sx={{ color: c.text, p: 2 }}>No Devices Found</Typography>
        ) : (
          <ExtentGrid maxExtent={250} childAspectRatio={0.9} gap={10}>
            {favourites.map((d) => (
              <DeviceCard
                key={d.UniqueNumber}
                device={d}
                showLocation
                onOpen={openDevice}
                onToggleFavourite={onStar}
              />
            ))}
          </ExtentGrid>
        )}
      </Box>
    </Box>
  );
}
